import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { formatPhone } from '../redux/FeedbackRedux';
var businesses = [];
var users = [];

function initialize() {
    jQuery('.holder-business .row-business').each(function() {
        businesses.push(jQuery(this).attr('id'));
        jQuery('.selector-business').find('#'+jQuery(this).attr('id')).addClass('hidden');
    });

    jQuery('.holder-user .row-user').each(function() {
        users.push(jQuery(this).attr('id'));
        jQuery('.selector-user').find('#'+jQuery(this).attr('id')).addClass('hidden');
    });

    jQuery('.bbusinesses').val(businesses);
    jQuery('.busers').val(users);

}

function loadBusinessGroupJS(){
    initialize();
    jQuery('.selector-user .user, .selector-business .business').click(function () {
        var html = jQuery(this).html().replace('fa-plus', 'fa-minus');
        jQuery(this).addClass('hidden');
        if (jQuery(this).hasClass('business')) {
            businesses.push(jQuery(this).attr('id'));
            setValues()
            jQuery('.holder-business').append(html);
            jQuery('.holder-business')[0].scrollTop = jQuery('.holder-business')[0].scrollHeight;
        } else {
            users.push(jQuery(this).attr('id'));
            setValues()
            jQuery('.holder-user').append(html);
            jQuery('.holder-user')[0].scrollTop = jQuery('.holder-user')[0].scrollHeight;
        }
        checkForNone();
    });

    jQuery('body').on('click', '.holder-user:not(.buttononly) .row-user, .holder-business:not(.buttononly) .row-business', function () {
        var id = jQuery(this).attr('id');

        jQuery(this).remove();
        if (jQuery(this).hasClass('row-business')) {
            chop(businesses, id);
            setValues()
            jQuery('.selector-business #' + id + ", .selector-business #"+id+">*").removeClass('hidden');
        } else {
            chop(users, id);
            setValues()
            jQuery('.selector-user #' + id + ", .selector-user #"+id+">*").removeClass('hidden');
        }
        checkForNone();
    });

    jQuery('body').on('click', '.holder-user.buttononly .row-user i, .holder-business.buttononly .row-business i', function () {
        if ($(this).hasClass('ignoreDefaultJsBehaviour')) {
            return;
        }

        var id = jQuery(this).parent().parent().attr('id');

        jQuery(this).parent().parent().remove();
        if (jQuery(this).parent().parent().hasClass('row-user')) {
            chop(users, id);
            setValues()
            jQuery('.selector-user #' + id).removeClass('hidden');
        } else {
            chop(businesses, id);
            setValues()
            jQuery('.selector-business #' + id).removeClass('hidden');
        }
        checkForNone();
    });

    function setValues() {
        jQuery('.bbusinesses').val(businesses);
        jQuery('.busers').val(users);
    }

    function checkForNone() {
        if (businesses.length > 0) {
            jQuery('.holder-business .none').addClass('hidden');
        }
        else {
            jQuery('.holder-business .none').removeClass('hidden');
        }
        if (users.length > 0) {
            jQuery('.holder-user .none').addClass('hidden');
        }
        else {
            jQuery('.holder-user .none').removeClass('hidden');
        }
    }

    function chop(array, id) {
        var index = array.indexOf(id);
        if (index > -1) {
            array.splice(index, 1);
        }
    }

    jQuery('.bg-save-button').click(function (e) {
        e.preventDefault();
        var message = null;
        var type = null;
        var valid = validateEmail(jQuery('.input-email').val());

        if (jQuery('.input-name').val() == '') {
            message = "You have not added a group name!";
            type = "danger";
        }

        if (jQuery('body').find('.holder-business .row-business').length < 1) {
            message = "You have not added any businesses!";
            type = "danger";
        }

        //you have not added a group name
        if (message) {
            showAlert(message, type);
        } else {
            $("#bgform").submit();
        }
    });

    function showAlert(message, type) {
        jQuery('body').find('.alert').addClass('alert-' + type);
        jQuery('body').find('.alert').text(message);
        jQuery('body').find('.alert').show();
        jQuery('body').find('.alert').removeClass('anim-scale-in');
        jQuery('body').find('.alert').removeClass('anim-scale-out');
        jQuery('body').find('.alert').addClass('anim-scale-in');
        setTimeout(function () {
            jQuery('body').find('.alert').hide();
        }, 3000);
    }

    function validateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        return (false)
    }

    jQuery(document).ready(function () {
        jQuery(".search-businesses").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            jQuery(".selector-business .business").filter(function () {
                jQuery(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            });
        });
    });

    jQuery(document).ready(function () {
        jQuery(".search-users").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            jQuery(".selector-user .user").filter(function () {
                jQuery(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            });
        });
    });

    jQuery(document).ready(function () {
        jQuery(".search-businessgroups").on("keyup", function () {
            var value = $(this).val().toLowerCase();
            jQuery(".bgroup-row").filter(function () {
                jQuery(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
            });
        });
    });

    jQuery('body').on('click', '.authorized-link', function (e) {
        e.preventDefault();
        var type = jQuery(this).attr('id');
        var bgid = jQuery(this).attr('data-id');
        var data = { business_group_id: bgid, user_id: window.current_user, business_id: 276, type: type };
        var url = "/feedback/get-manage-sidebar-link";
        var manage_url = window.manage_server;
        jQuery.get(url, data, function (result) {
            window.open(manage_url + "/index/sso?token=" + result, '_blank');
        });
    });

    jQuery('body').on('change', '#parent_id', function(e){
        var id = jQuery(this).val();
        var type = jQuery('body').find('option#'+id).attr('data-type');
        jQuery('body').find('.parent_type').val(type);
    });


}



window.loadBusinessGroupJS = loadBusinessGroupJS;
